import { exportExcelFactory } from "../../utils/export-excel";
import { DownloadIcon } from 'src/components/ui-icons/upload';
import { RequirementDirection, Department } from "../../types/data";

type ExportExcelFactoryProps = {
  data: RequirementDirection[];
  departments: Department[];
}

function ExportExcelFactory({ data, departments }: ExportExcelFactoryProps) {
  console.log('ExportExcelFactory', data)
  return (
    <button
      className="inline-flex items-center border font-medium rounded-md px-4 justify-center gap-x-2 text-darkblue bg-white hover:bg-gray-50 shadow-custom text-base lg:px-6 py-3 sm:px-4 ml-auto"
      type="button"
      onClick={() => exportExcelFactory(data, departments)}>
      <DownloadIcon /> Скачать в Excel
    </button>
  )
}

export default ExportExcelFactory;
